import { render, staticRenderFns } from "./RecentVerifications.vue?vue&type=template&id=a059ac7a&scoped=true"
import script from "./RecentVerifications.vue?vue&type=script&lang=js"
export * from "./RecentVerifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a059ac7a",
  null
  
)

export default component.exports